module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmh3"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("List of Plates")])]), _vm._v(" "), _c('p', {
    staticClass: "entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Plates_Section#photo1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The bronze statue of Hotspur in Alnwick")])]), _vm._v(" "), _c('p', {
    staticClass: "entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Plates_Section#photo2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Arms of Sir Henry Percy’")])]), _vm._v(" "), _c('p', {
    staticClass: "entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Plates_Section#photo3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alnwick Castle")])]), _vm._v(" "), _c('p', {
    staticClass: "entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Plates_Section#photo4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Warkworth Castle")])]), _vm._v(" "), _c('p', {
    staticClass: "entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Plates_Section#photo5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bamburgh Castle")])]), _vm._v(" "), _c('p', {
    staticClass: "entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Plates_Section#photo6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The walls of Berwick-upon-Tweed")])]), _vm._v(" "), _c('p', {
    staticClass: "entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Plates_Section#photo7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The remains of the castle at Berwick")])]), _vm._v(" "), _c('p', {
    staticClass: "entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Plates_Section#photo8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dunstanburgh Castle")])]), _vm._v(" "), _c('p', {
    staticClass: "entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Plates_Section#photo9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Facsimile armour of the fourteenth century")])]), _vm._v(" "), _c('p', {
    staticClass: "entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Plates_Section#photo10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Newcastle Keep")])]), _vm._v(" "), _c('p', {
    staticClass: "entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Plates_Section#photo11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Otterburn battlefield memorial")])]), _vm._v(" "), _c('p', {
    staticClass: "entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Plates_Section#photo12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A general view of Otterburn battlefield")])]), _vm._v(" "), _c('p', {
    staticClass: "entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Plates_Section#photo13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Looking east at Otterburn")])]), _vm._v(" "), _c('p', {
    staticClass: "entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Plates_Section#photo14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Silloans Sword")])]), _vm._v(" "), _c('p', {
    staticClass: "entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Plates_Section#photo15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The replica Silloans Sword")])]), _vm._v(" "), _c('p', {
    staticClass: "entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Plates_Section#photo16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elsdon church")])]), _vm._v(" "), _c('p', {
    staticClass: "entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Plates_Section#photo17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Neville effigies, Staindrop church")])]), _vm._v(" "), _c('p', {
    staticClass: "entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Plates_Section#photo18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A medieval spur, recovered from the vicinity of Albright Hussey")])]), _vm._v(" "), _c('p', {
    staticClass: "entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Plates_Section#photo19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Otterburn battlefield walk participants")])]), _vm._v(" "), _c('p', {
    staticClass: "entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Plates_Section#photo20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An aerial view of Battlefield church and its environs in Shrewsbury")])]), _vm._v(" "), _c('p', {
    staticClass: "entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Plates_Section#photo21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Battlefield church")])]), _vm._v(" "), _c('p', {
    staticClass: "entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Plates_Section#photo22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The effigy of Simon Mewburn, Church of St John of Beverley, St John’s Lee")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d2091ef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Plates.vue
// module id = 87
// module chunks = 0